import { Button } from "react-bootstrap";
import { TopographNavbar } from "../components/TopographNavbar";
import bgJPG from "../assets/bg.jpg";

export function Index() {
    return (
        <>
            <TopographNavbar />
            <div
                style={{
                    backgroundImage: `url(${bgJPG})`,
                    height: "100vh",
                    backgroundSize: "auto 100%",
                }}
            >
                <div style={{ marginLeft: "5rem", maxWidth: "55rem", paddingTop: "9rem" }}>
                    <h1>Beautiful maps for your wall</h1>
                    This site - topograph.dev - is dedicated to selling&nbsp;<i>you</i>
                    &nbsp;beautiful, high-quality relief maps of anywhere on Earth.
                    <br />
                    <br />
                    <h3>A truly unique map</h3>
                    Our&nbsp;<a href="/create">online tool</a> has data for almost everywhere on Earth,
                    from rural small towns to towering megacities. Get a unique and thoughtful
                    gift for anyone.
                    <br />
                    <br />
                    <h3>Digital craftsmanship</h3>
                    Each part of your map is 3D printed in your specified colors. The frame is veneered
                    with real walnut or birch. The entire map assembles precisely into a seamless
                    product on your wall.
                    <br />
                    <br />
                    <h3>A gift they'll love</h3>
                    Details about the map are printed on a plaque - the location, date, and space
                    for a heartfelt message. Our products pack well, and always come with a detailed,
                    hassle-free hanging or setup guide.
                    <hr />
                    <Button
                        variant="outline-warning"
                        onClick={() => {
                            window.location.href = "/create";
                        }}
                    >
                        Create yours now <i className="bi bi-arrow-right" />
                    </Button>
                </div>
            </div>
        </>
    );
}
